import React, {FC, useCallback, useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {GoPlus} from 'react-icons/go';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
// custom
import { getEventsAdmin, deleteEventById } from '../../../common/async/AsyncCalls';
import { EVENT_ACTION_TYPE, IEvent } from '../../../common/state/events/event';
import { IUserState } from '../../../common/state/profile/user';
import NavbarAdmin from '../../../components/navbar/Navbar.admin';
import EventPreviewAdmin from './view/Event.preview.admin';
import EventAdminMuiTable from '../../../components/tables/Event.admin.material.table';
// custom

const EventsView : FC = () => {
    const history = useHistory();
    // states
    const [isPreview, togglePreview] = useState(false);
    const [eventList, setEventList] = useState<IEvent[] | undefined>(undefined);
    const token: string = useSelector(({user} : {
        user: IUserState
    }) => user.token);
    // actions
    const eventDispatch : (data : {type: EVENT_ACTION_TYPE, payload: any}) => void = useDispatch();

    // evt handlers
    function handleEventUpdate (event: IEvent) {
        // console.log('Update event: ', event);
        eventDispatch({type: EVENT_ACTION_TYPE.SELECT_EVENT, payload: event});
        history.push({pathname: '/admin/events/update'});
    }
    
    function handleEventPreview (event: IEvent) {
        eventDispatch({type: EVENT_ACTION_TYPE.SELECT_EVENT, payload: event});
        togglePreview(true);
    }

    // lifecycle
    const handleDeleteEvent = useCallback(async(item: IEvent)=>{
        console.log('Delete event', item);                        
        try {
            await deleteEventById(token, item.id);
            toast("Event deleted successfully!");
            eventDispatch({type: EVENT_ACTION_TYPE.RESET_EVENT, payload: undefined});
            history.push({pathname: '/admin'});
        } catch (err) {
            console.log('Error deleting event: ', (err as Error).message);
        }
    },[token]);

    //lifecycle
    const fetchAllEvents = useCallback(async()=> {
        try {
            // console.log('Token is: ', token);
            const response = await getEventsAdmin(token);
            // console.log('details are: ', response.data);
            setEventList(response.data as IEvent[]);
        } catch(err) {
            console.log('Error fetching admin events');
        }
            
    }, [token]);

    useEffect(()=>{        
        fetchAllEvents();
    },[token]);
    return <React.Fragment>
        <NavbarAdmin/>
        <div
            className="h-screen overflow-y-scroll w-screen bg-gray-200 dark:bg-gray-800 flex flex-col justify-start p-4 
                        lg:py-4 lg:px-16 items-between shadow">
            <h2 className="text-gray-700 dark:text-teal-400 text-2xl font-medium mb-2">Manage Events</h2>
            <p className="text-gray-700 dark:text-gray-300 dartext-base mb-4">
                Create, Update, Delete events. The Event with "Active" status will be seen by the customer. Please note to ensure atleast one of the event is always active*
            </p>
            <section className="w-full flex flex-row justify-end">
                <Link to="/admin/events/create" className="bg-primary-500 text-white flex 
                        active:bg-primary-600 font-bold uppercase text-sm px-6 py-3 rounded shadow 
                        hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear 
                        transition-all duration-150" type="button">
                     <GoPlus className="relative mt-1 mr-2 font-bold"/> Event
                </Link>
            </section>
            <EventAdminMuiTable
                list={eventList}
                onEdit={handleEventUpdate}
                onView={handleEventPreview}
                onDelete={handleDeleteEvent}/>
            <EventPreviewAdmin display={isPreview}/>
        </div>
    </React.Fragment>;
};

export default EventsView;
